import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 14v-6h6","key":"svg-0"}],["path",{"d":"M3 8l9 9l9 -9","key":"svg-1"}]]

/**
 * IconArrowElbowLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctZWxib3ctbGVmdCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMyAxNHYtNmg2IiAvPgogIDxwYXRoIGQ9Ik0zIDhsOSA5bDkgLTkiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/arrow-elbow-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowElbowLeft = createReactComponent('outline', 'arrow-elbow-left', 'ArrowElbowLeft', __iconNode);

export default IconArrowElbowLeft;